import React, { useState, useCallback } from 'react';
import {withRouter} from 'react-router-dom';
import {getSubmenu, hasMenuAccess} from '../../utils/const';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

// checkAccess включает проверку прав по полю access у подпунктов. Передаётся только
// из меню ЛК постоянного состава — в ЛК переменного состава видимость не меняется.
// Правило доступа живёт в utils/const (hasMenuAccess) — один источник с поиском по меню.
const MenuLink = ({name, to, history, checkAccess}) => {

    const accessModes = useSelector(state => state.auth.access_modes);
    const { t } = useTranslation();

    const [isOpen, setIsOpen] = useState(false);

    const handleMouseEnter = useCallback(() => setIsOpen(true), []);
    const handleMouseLeave = useCallback(() => setIsOpen(false), []);

    const redirect = useCallback((redirectTo) => (event) => {
        event.stopPropagation();
        setIsOpen(false);
        history.replace(redirectTo);
    }, [history]);

    const submenu = getSubmenu(to)
        .filter(item => hasMenuAccess(accessModes, item.access, checkAccess));

    // Верхний пункт без доступных подпунктов скрываем целиком
    if (!submenu.length) return null;

    const path = history.location.pathname;
    const pathContainsTo = path.contains ? path.contains(to) : path.includes(to);

    return (
        <div
            className={`${pathContainsTo ? 'active' : ''} links`}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            {name}
            <div className={`menu_dropdown ${isOpen ? 'menu_dropdown--open' : ''}`}>
                {submenu.map(item => (
                    <div key={item.to} onClick={redirect(item.to)}>{t(item.name)}</div>
                ))}
            </div>
        </div>
    );
};
const MenuLinkWithRouter = withRouter(MenuLink);

export default MenuLinkWithRouter;
